import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZPlayerSelectPrivate } from '../../player/models';
import { ZPrizeSelect } from '../../prize/models';
import {
  ZDrawAndPrizeResult,
  ZDrawResult,
  ZDrawScheduleSelect,
  ZDrawSelect,
  ZDrawTypePlanSelect,
  ZDrawTypeSelect,
  ZGetDrawResults,
} from './models';

const c = initContract();
export const publicDrawContract = c.router(
  {
    getDrawTypeCached: {
      method: 'GET',
      path: '/draw-type/:draw_code',
      responses: {
        200: z.object({
          draw_type: ZDrawTypeSelect,
          draw_type_plans: z.array(ZDrawTypePlanSelect),
          draw_schedules: z.array(ZDrawScheduleSelect),
          next_draw: z.optional(
            ZDrawSelect.extend({
              prize: ZPrizeSelect.pick({
                title: true,
                type: true,
                imageLocations: true,
                seoImageAltText: true,
                overviewBody: true,
                whatsIncludedHeading: true,
                whatsIncludedBody: true,
              }).nullable(),
            }),
          ),
        }),
        404: c.type<{ message: string }>(),
      },
    },
    getDrawTypeGroup: {
      method: 'GET',
      path: '/draw-type/group/:group',
      responses: {
        200: z.array(
          z.object({
            draw_type: ZDrawTypeSelect,
            draw_type_plan: ZDrawTypePlanSelect,
            draw_schedule: ZDrawScheduleSelect,
            draw: ZDrawSelect,
          }),
        ),
        404: c.type<{ message: string }>(),
      },
    },
    calcDrawCost: {
      method: 'GET',
      path: '/draw-type/:draw_code/cost',
      responses: {
        200: z.object({
          draw_type: ZDrawTypeSelect,
          draw_type_plans: z.array(ZDrawTypePlanSelect),
          next_draw: z.optional(ZDrawSelect),
        }),
        404: c.type<{ message: string }>(),
      },
    },
    getDrawResults: {
      method: 'GET',
      path: '/results',
      query: z.object({
        limit: z.optional(z.coerce.number()),
        draw_code: z.optional(z.string()),
      }),
      responses: {
        200: ZGetDrawResults,
      },
    },
    getDrawResult: {
      method: 'GET',
      path: '/result',
      query: z.object({
        draw_id: z.optional(z.coerce.number()),
        draw_code: z.optional(z.string()),
      }),
      responses: {
        200: ZDrawResult,
        404: c.type<{ message: string }>(),
      },
    },
    getDrawRangesByDrawId: {
      method: 'GET',
      path: '/range/:draw_id',
      pathParams: z.object({
        draw_id: z.coerce.number(),
      }),
      responses: {
        200: z.object({
          ballRanges: z.array(z.number()),
          usingBonusBall: z.boolean(),
        }),
      },
    },
    getTokenTownResults: {
      method: 'GET',
      path: '/token-town-results',
      responses: {
        200: z.array(ZDrawAndPrizeResult),
      },
    },
    getLatestCompletedWeeklyDrawId: {
      method: 'GET',
      path: '/latest-completed-weekly-draw-id',
      responses: {
        200: z.number(),
      },
    },
    getLastRafflePrizeAndWinner: {
      method: 'GET',
      path: '/last-raffle-prize-and-winner/:draw_schedule_code',
      pathParams: z.object({
        draw_schedule_code: z.string(),
      }),
      responses: {
        200: z.object({
          prize: ZPrizeSelect.pick({
            title: true,
            imageLocations: true,
          }).nullable(),
          winner: ZPlayerSelectPrivate.pick({
            firstName: true,
          }).nullable(),
        }),
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/public',
    strictStatusCodes: true,
  },
);
